import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import VoterID2OutputComponent from '../output/VoterID2OutputComponent';

const VoterID2InputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-id-card', title: 'Voter ID Verification (v2)', subtitle: 'Enhanced Voter ID verification via Gridlines' }}
        fields={[
            // Format-check the EPIC before it can reach a BILLABLE provider call
            // (#403). Without a regex, SimpleReportForm.validate() only enforces
            // non-empty, so a fat-fingered "ABC123" passed validation, cleared the
            // confirm dialog and spent a credit on a lookup that could only fail.
            // Matches the placeholder and the sibling PAN2/RCDetails components,
            // which have always validated their primary billable id.
            { name: 'voter_id', label: 'Voter ID (EPIC)', icon: 'pi-id-card', placeholder: 'ABC1234567', maxLength: 10, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true,
              regex: /^[A-Z]{3}[0-9]{7}$/, regexError: 'EPIC must be 3 letters followed by 7 digits (e.g. ABC1234567)',
              colClass: 'col-12 md:col-6 lg:col-4' },
        ]}
        endpoint={{
            path: '/gridlines/voter-id-details',
            bodyMapper: (v, sid) => ({ voter_id: v.voter_id, consent: 'Y', api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="voter-id"
        submitLabel="Verify Voter ID"
        successSummary="Voter ID verified"
        errorSummary="Voter ID verification failed"
        confirmHeader="Confirm Voter ID verification"
        confirmAcceptLabel="Yes, verify"
        // Authenticated blob download, same as DL v2 and PAN v2. The old button
        // opened the `pdf_download_url` from the verify response in a new tab —
        // but that URL carries a smart token cached for 24h, so the link died on
        // expiry or on any `cache:clear` while the URL lived on in the DB.
        pdfEndpoint={(reportId) => `/gridlines/voter-id-v2/${reportId}/download-pdf`}
        pdfPasswordHint='Last 4 characters of your Voter ID + "VOTER" (Example: If Voter ID is ABC1234567, password is 4567VOTER)'
        outputComponent={VoterID2OutputComponent}
    />
);

export default VoterID2InputComponent;
